import {
  Component,
  OnInit,
  OnDestroy,
  HostListener,
  ElementRef,
  ViewChild,
  Renderer2,
  ViewChildren,
  QueryList,
  AfterViewInit,
} from "@angular/core";
import { ApiService } from "src/app/services/api/api.service";
import { Subscription, combineLatest, BehaviorSubject } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { Router } from "@angular/router";
import { IAppState } from "src/app/store/states/app";
import { Store } from "@ngrx/store";
import {
  selectManageOwnAuctions,
  selectAuthenticatedUserMe,
  selectIsAuthenticating,
} from "src/app/store/selectors";
import * as moment from "moment";
import { $, element } from "protractor";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
  FormArray,
} from "@angular/forms";
import { BidUpdateService } from "src/app/services/bid-update.service";
import { ClockService } from "src/app/services/clock.service";
import { ModalService } from "../../modal/services/modal.service";
import BSN from "bootstrap.native";
import { HttpErrorResponse } from "@angular/common/http";
import { selectAuctionStatuses } from "src/app/store/selectors/shared.selector";

const actionIds = {
  view: 1,
  edit: 2,
  publish: 3,
  duplicate: 4,
  finish: 5,
  fail: 6,
  stop: 7,
  delete: 8,
  cancelPublish: 9,
};

interface filterQueryParams {
  statuses?: string;
  active_to?: string;
  active_from?: string;
}

interface actionConfirmationModalContent {
  uuid: string;
  title: string;
  actionId: number;
}

@Component({
  selector: "app-my-auctions",
  templateUrl: "./my-auctions.component.html",
  styleUrls: ["./my-auctions.component.scss"],
})
export class MyAuctionsComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChildren("buttonRef") buttonRef: QueryList<any>;
  @ViewChildren("modalRef") modalRef: QueryList<any>;

  public isAllResultsModalOpen: boolean = false;
  public allResultsForm: FormGroup;
  public isModalStatusFilterOpen: boolean = false;
  public isModalDateFilterOpen: boolean = false;
  public allResultsDataFailed: boolean = false;

  public isFormModalOpen = "";
  public isResultsModalOpen: boolean = false;
  public parentTabs: Array<any> = [];

  public auctionStopModalLoader: boolean = false;

  private userInformation;

  private bidUpdateSubscription: Subscription;
  public auctionResultsData = null;

  private serverTimeSubscription: Subscription;
  private serverTime;

  private filterDropdownWeb;
  private filterDropdownMobile;

  private readonly actions = [
    {
      id: actionIds.view,
      name: "ნახვა",
      isActive: true,
    },
    {
      id: actionIds.edit,
      name: "რედაქტირება",
      isActive: true,
    },
    {
      id: actionIds.publish,
      name: "გამოქვეყნება",
      isActive: true,
    },
    {
      id: actionIds.cancelPublish,
      name: "გამოქვეყნების გაუქმება",
      isActive: true,
    },
    {
      id: actionIds.duplicate,
      name: "დუბლირება",
      isActive: true,
    },
    // {
    //   id: actionIds.finish,
    //   name: 'დასრულება',
    //   isActive: true,
    // },
    // {
    //   id: actionIds.fail,
    //   name: 'ჩაშლა',
    //   isActive: true,
    // },
    {
      id: actionIds.stop,
      name: "შეწყვეტა",
      isActive: true,
    },
    {
      id: actionIds.delete,
      name: "წაშლა",
      isActive: true,
    },
  ];

  public endedAuctionTypes = {
    endedAuctionBuyNowType: "buy-now",
    endedStandardAuctionType: "standard",
  };

  // public tabs = [
  //   {
  //     title: 'აუქციონები',
  //     id: 1
  //   },
  //   {
  //     title: 'მიმდინარე',
  //     id: 2
  //   },
  //   {
  //     title: 'მოგებული',
  //     id: 3
  //   },
  //   {
  //     title: 'გამოუქვეყნებელი',
  //     id: 4
  //   },
  // ];

  private actionsModalComponent = "";

  private auctionStatuses: Array<any> = [];
  private auctionStatusesSubscription: Subscription;
  private readonly parentTabTypes = {
    manageable: "manageable",
    participated: "participated",
  };
  private currentParentTab: string = this.parentTabTypes.manageable;
  private currentParentTabSubject = new BehaviorSubject(this.currentParentTab);
  private currentParentTabSubscription: Subscription;
  public currentTab: number = 1;
  public statusValue = null;

  private myAuctionsSubscription: Subscription;
  private myAuctions: Array<any> = [];
  private canUserManageOwnAuctions;

  private lastPage: number;
  private currentPageNumber: number;
  private paginationData = {};
  public total: number = 0;

  private manualStopReasonForm: FormGroup;

  public actionConfirmationModalState: Boolean = false;
  public actionConfirmationModalContent: actionConfirmationModalContent;
  public actionConfirmationModalLoader: Boolean = false;

  private isStatusOpen: Boolean;
  private isDateFilterOpen: Boolean;
  private auctionFilterForm: FormGroup;

  constructor(
    private renderer: Renderer2,
    private apiService: ApiService,
    private router: Router,
    private _store: Store<IAppState>,
    private formBuilder: FormBuilder,
    private bidUpdateService: BidUpdateService,
    private clockService: ClockService,
    private modalService: ModalService,
  ) {
    this.currentParentTabSubscription = this.currentParentTabSubject.subscribe(
      (tab) => {
        if (tab === this.parentTabTypes.manageable) {
          this.auctionStatuses.splice(0, 0, {
            key: "unpublished",
            display_name: "გამოუქვეყნებელი",
          });
          this.auctionStatuses = [...this.auctionStatuses];
        } else if (tab === this.parentTabTypes.participated) {
          this.auctionStatuses = this.auctionStatuses.filter(
            (item) => item.key !== "unpublished",
          );
        }
        this.currentParentTab = tab;
        if (this.filterForm) {
          this.filterForm.reset();
        }
      },
    );

    combineLatest(
      this._store.select(selectManageOwnAuctions),
      this._store.select(selectAuthenticatedUserMe),
      this._store.select(selectIsAuthenticating),
    ).subscribe(([manageAuctions, user, authenticating]) => {
      this.canUserManageOwnAuctions = manageAuctions;
      if (!authenticating && user) {
        this.userInformation = user;
        if (this.canUserManageOwnAuctions) {
          this.parentTabs = [
            {
              title: "მართვა",
              id: this.parentTabTypes.manageable,
            },
            {
              title: "მონაწილე",
              id: this.parentTabTypes.participated,
            },
          ];
        } else {
          this.currentParentTabSubject.next(this.parentTabTypes.participated);

          this.parentTabs = [
            {
              title: "მონაწილე",
              id: this.parentTabTypes.participated,
            },
          ];
        }
        this.getParentData();
      }
    });
  }

  print(tabName: string): void {
    let printContents, popupWin;
    if (tabName === "manageable") {
      printContents = document.getElementById(
        "print-manageable-section",
      ).innerHTML;
    } else {
      printContents = document.getElementById(
        "print-participated-section",
      ).innerHTML;
    }
    // popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto'); in case popup is needed
    popupWin = window.open("", "_blank");
    popupWin.document.open();
    if (tabName === "manageable") {
      popupWin.document.write(`
      <html>
        <head>
          <title>შედეგები</title>
          <style>
            body div {display:flex;}
            p:first-of-type {margin-right:30px;}
          </style>
        </head>
        <body onload="window.print();">${printContents}</body>
      </html>`);
    }
    if (tabName === "participated") {
      popupWin.document.write(`
      <html>
        <head>
          <style>
            img {width:150px; margin-left: 30px; margin-top: 30px;}
            p,label { margin: 0; padding: 0;font-family: FiraGO-bold; margin-bottom: 0.5rem}
            table { width: 100%;border-collapse: collapse;}
            td:first-of-type {min-height: 200px;height: 100%; padding: 1rem 0.5rem;}
            td, th {padding: 1em 0.5em 1em 0.5em}
            table,tbody,th,td {border: 1px solid black;}
            th:not(:first-child ), td:not(:first-child ){ text-align: center !important;}
            th:first-of-type {padding-left: 0.5rem}
            th, td{text-align: left;}
            .print {margin: 10px;}
            .print-body {margin-top: 30px; }
            .print-content {width: 90%;margin-top: 50px;margin-left: auto;margin-right: auto;}
            .info { margin-top: 30px;}
            .info-label {-webkit-text-stroke: 0.015em rgb(0,0,0);}
            .border-right-none { border-right: none;}
            .border-left-none {border-left: none;}
            text-align-center {text-align: center;}
            .print-footer {position: fixed;display: flex;justify-content: center;align-items: center;bottom: 0;margin-bottom: 30px;background: #0045ff;color: #fff;width: 100%;padding: 20px;-webkit-print-color-adjust: exact;}

            @page
            {
              size:  auto;   /* auto is the initial value */
              margin: 0mm;  /* this affects the margin in the printer settings */
            }
            body
            {
              margin: 0; /* margin you want for the content */
            }
          </style>
        </head>
        <body onload="window.print();">
          ${printContents}
        </body>
      </html>`);
    }
    popupWin.document.close();
  }

  ngOnInit() {
    this.auctionStatusesSubscription = this._store
      .select(selectAuctionStatuses)
      .subscribe((auctionStatuses) => (this.auctionStatuses = auctionStatuses));
    this.manualStopReasonForm = this.formBuilder.group({
      reason: new FormControl("", [
        Validators.required,
        Validators.minLength(10),
      ]),
      files: new FormArray([], [Validators.required]),
    });

    this.auctionFilterForm = this.formBuilder.group({
      status: new FormArray([]),
      active_from: new FormControl(""),
      active_to: new FormControl(""),
    });

    // this.allResultsForm = this.formBuilder.group({
    //   statuses: new FormArray([], [Validators.required]),
    //   start_date: new FormControl(null, [Validators.required]),
    //   end_date: new FormControl(null, [Validators.required])
    // });

    this.serverTimeSubscription = this.clockService.clock.subscribe((time) => {
      this.serverTime = time;
    });
  }

  ngAfterViewInit() {
    this.renderer.listen("window", "click", (e: Event) => {
      if (
        !this.buttonRef.some((item) => item.nativeElement === e.target) &&
        !this.modalRef.some((item) => item.nativeElement === e.target)
      ) {
        this.actionsModalComponent = "";
      }
    });

    this.filterDropdownMobile = new BSN.Dropdown("#filterDropdownMobile", true);
    this.filterDropdownWeb = new BSN.Dropdown("#filterDropdownWeb", true);

    // this.allResultsForm.valueChanges.subscribe(() => {
    //   if (this.allResultsForm.valid) {

    //     this.getAllResultsData();
    //   }
    // });
  }

  getAllResultsData(): void {
    this.closeModalStatusesState();
    this.closeModalDateState();
    this.allResultsDataFailed = true;
  }

  modalStatusesState(): void {
    this.isModalStatusFilterOpen = !this.isModalStatusFilterOpen;
    if (this.isModalStatusFilterOpen) {
      this.closeModalDateState();
    }
    this.clearAllResultsDataFailed();
  }

  modalDateState(): void {
    this.isModalDateFilterOpen = !this.isModalDateFilterOpen;
    if (this.isModalDateFilterOpen) {
      this.closeModalStatusesState();
    }
    this.clearAllResultsDataFailed();
  }

  closeModalStatusesState(): void {
    this.isModalStatusFilterOpen = false;
  }

  closeModalDateState(): void {
    this.isModalDateFilterOpen = false;
  }

  clearAllResultsDataFailed(): void {
    if (this.allResultsDataFailed) {
      this.allResultsDataFailed = false;
    }
  }

  closeAllResultsModal(): void {
    this.isAllResultsModalOpen = false;
    this.closeModalDateState();
    this.closeModalStatusesState();
    this.clearAllResultsDataFailed();
  }

  openAllResultsModal(): void {
    this.isAllResultsModalOpen = true;
  }

  importAllResults(): void {
    // console.log('Results');
  }

  // buttons
  auctionManuallyFail(uuid) {
    const requestData = new FormData();
    requestData.append("_method", "patch");
    this.apiService
      .patch(`auctions/management/${uuid}/manually-fail`, requestData)
      .pipe(map((response: any) => response))
      .subscribe((response) => {
        if (response.result) {
          this.updateAuctionData(response.data);
        }
      });
  }

  auctionManuallyFinish(uuid) {
    const requestData = new FormData();
    requestData.append("_method", "patch");
    this.apiService
      .patch(`auctions/management/${uuid}/manually-finish`, requestData)
      .pipe(map((response: any) => response))
      .subscribe((response) => {
        if (response.result) {
          this.updateAuctionData(response.data);
          this.actionsModalComponent = "";
        }
      });
  }

  checkParticipatedWonAuctions(item) {
    return (
      (item.status_key === "finished" ||
        item.status_key === "manually_finished") &&
      item.last_bid &&
      this.userInformation &&
      this.userInformation.uuid === item.last_bid.user_uuid
    );
  }

  auctionDelete(uuid) {
    this.actionConfirmationModalLoader = true;
    let index;
    const requestData = new FormData();
    requestData.append("_method", "patch");
    this.myAuctions.find((item) => {
      if (item.uuid === uuid) {
        index = this.myAuctions.indexOf(item);
      }
    });

    this.apiService
      .patch(`auctions/management/${uuid}/delete`, requestData)
      .pipe(map((response: any) => response))
      .subscribe(
        (response) => {
          if (response.result) {
            this.myAuctions.splice(index, 1);
            this.actionsModalComponent = "";
            this.actionConfirmationModal(false);
          }
        },
        (err) => {
          this.actionConfirmationModalLoader = false;
        },
      );
  }

  auctionStop(uuid) {
    this.auctionStopModalLoader = true;
    const requestData = new FormData();
    requestData.append("_method", "patch");
    requestData.append("reason", this.manualStopReasonForm.get("reason").value);

    for (const index in this.manualStopReasonForm.get("files").value) {
      requestData.append(
        `files[]`,
        this.manualStopReasonForm.get("files").value[index],
      );
    }

    this.apiService
      .post(
        `auctions/management/${uuid}/stop?reason=${this.manualStopReasonForm.get("reason").value}`,
        requestData,
      )
      .pipe(
        map((response: any) => response),
        catchError((resp) => {
          const errorKeys = Object.entries(resp.error.errors);
          errorKeys.forEach(([key, val]) => {
            const err = {};
            err[key] = val;
            this.form.get(key).setErrors(err);
          });
          return "error";
        }),
      )
      .subscribe(
        (response) => {
          if (response.result) {
            this.updateAuctionData(response.data);
            this.actionsModalComponent = "";
            this.closeFormModal();
          }
        },
        (err) => {
          this.auctionStopModalLoader = false;
        },
      );
  }

  auctionPusblish(uuid) {
    this.actionConfirmationModalLoader = true;
    const requestData = new FormData();
    requestData.append("_method", "patch");
    this.apiService
      .patch(`auctions/management/${uuid}/publish`, requestData)
      .pipe(map((response: any) => response))
      .subscribe(
        (response) => {
          if (response.result) {
            this.updateAuctionData(response.data);
            this.actionsModalComponent = "";
            this.actionConfirmationModal(false);
          }
        },
        (err) => {
          this.actionConfirmationModalLoader = false;
        },
      );
  }

  auctionCancelPusblishRequest(uuid) {
    this.actionConfirmationModalLoader = true;
    const requestData = new FormData();
    requestData.append("_method", "patch");
    this.apiService
      .patch(`auctions/management/${uuid}/cancel-publish-request`, requestData)
      .pipe(map((response: any) => response))
      .subscribe(
        (response) => {
          if (response.result) {
            this.updateAuctionData(response.data);
            this.actionsModalComponent = "";
            this.actionConfirmationModal(false);
          }
        },
        (err) => {
          this.actionConfirmationModalLoader = false;
        },
      );
  }

  // /buttons

  updateAuctionData(auction) {
    this.myAuctions.find((item) => {
      if (item.uuid === auction.uuid) {
        const index = this.myAuctions.indexOf(item);
        this.myAuctions[index] = Object.assign({}, auction);
      }
    });
  }

  filterStatusChanges() {
    this.makePaginationPageDefault();
    this.getParentData();
  }

  changeParrent(id) {
    this.statusValue = null;
    this.makePaginationPageDefault();
    this.currentParentTabSubject.next(id);
    // this.currentParentTab = id;
    this.currentTab = 1;
    this.getParentData();
  }

  makePaginationPageDefault(): void {
    this.paginationData = {};
  }

  getParentData() {
    const formData = {};
    if (this.currentTab === 2) {
      formData["statuses"] = "active";
    }

    if (
      this.currentTab === 3 &&
      this.currentParentTab === this.parentTabTypes.participated
    ) {
      formData["won"] = "1";
    } else if (
      this.currentTab === 3 &&
      this.currentParentTab === this.parentTabTypes.manageable
    ) {
      formData["statuses"] = "finished";
    } else if (
      this.currentTab === 4 &&
      this.currentParentTab === this.parentTabTypes.manageable
    ) {
      formData["statuses"] = "unpublished";
    }

    if (this.statusValue && this.currentTab === 1) {
      formData["statuses"] = this.statusValue;
    }

    // changed status to statuses above

    const requestData = { ...formData, ...this.paginationData };

    if (this.filterForm) {
      requestData["statuses"] = "";
      requestData["statuses"] = this.filterForm.get("status").value.join(",");
      if (this.filterForm.get("active_from").value) {
        requestData["active_from"] = this.formatFilterDate(
          this.filterForm.get("active_from").value,
        );
      }
      if (this.filterForm.get("active_to").value) {
        requestData["active_to"] = this.formatFilterDate(
          this.filterForm.get("active_to").value,
        );
      }
      // this.filterForm.get('status').value.forEach(item => {
      //   if (item) {
      //     requestData['statuses'] = item;
      //   }
      // });
    }

    this.myAuctionsSubscription = this.apiService
      .get(`profile/auctions/${this.currentParentTab}?per_page=15`, {
        observe: "response",
        params: requestData,
      })
      .pipe(
        map((response) => response.body),
        catchError((response: HttpErrorResponse) => {
          const errorKeys = Object.entries(response.error.errors);
          errorKeys.forEach(([key, val]) => {
            const err = {};
            err[key] = val;
            this.filterForm.get(key).setErrors(err);
          });
          return "error";
        }),
      )
      .subscribe((response) => {
        if (response.result) {
          this.myAuctions = response.data.data;
          this.lastPage = response.data.last_page;
          this.currentPageNumber = response.data.current_page;
          this.total = response.data.total;
          this.fBidUpdate();
        }
      });
  }

  fBidUpdate() {
    this.bidUpdateSubscription = this.bidUpdateService.updatedData.subscribe(
      (resp) => {
        if (Object.keys(resp).length !== 0) {
          for (let i = 0; i < this.myAuctions.length; i++) {
            if (this.myAuctions[i].uuid === resp.auction.uuid) {
              this.myAuctions[i].last_bid = resp.last_bid;
              this.myAuctions[i] = Object.assign(
                this.myAuctions[i],
                resp.auction,
              );
            }
            if (
              this.auctionResultsData &&
              resp.auction.uuid === this.auctionResultsData.uuid
            ) {
              this.auctionResultsData.last_bid = resp.last_bid;
              this.auctionResultsData = Object.assign(
                this.auctionResultsData,
                resp.auction,
              );
            }
          }
        }
      },
    );
  }
  getChildData(id) {
    this.makePaginationPageDefault();
    this.currentTab = id;
    this.getParentData();
  }

  goToEdit(id) {
    this.router.navigate(["auction/edit/" + id]);
  }

  goToDuplicate(id) {
    this.router.navigate([`auction/create/${id}`]);
  }

  formatDate(date, withMinutes = false, days?) {
    if (days) {
      return moment(date)
        .locale("ka")
        .add(days, "d")
        .format(`DD MMM, YYYY ${withMinutes ? "HH:mm:ss" : ""}`);
    } else {
      return moment(date)
        .locale("ka")
        .format(`DD MMM, YYYY ${withMinutes ? "HH:mm:ss" : ""}`);
    }
  }

  formatFilterDate(date) {
    return moment(date).locale("ka").format(`YYYY-MM-DD HH:mm:ss`);
  }

  fPagination(pageNum: number | string) {
    this.paginationData["page"] = pageNum;
    this.getParentData();
  }

  increaseCurrentPage() {
    if (this.currentPage < this.lastPage) {
      this.currentPageNumber++;
      this.fPagination(this.currentPageNumber);
    }
  }

  decreaseCurrentPage() {
    if (this.currentPage > 1) {
      this.currentPageNumber--;
      this.fPagination(this.currentPageNumber);
    }
  }

  actionsModal(uuid = "") {
    if (this.actionsModalComponent === uuid) {
      this.actionsModalComponent = "";
    } else {
      this.actionsModalComponent = uuid;
    }
  }

  makeAction(actionId, uuid, actionName) {
    this.actionConfirmationModalContent = {
      uuid,
      actionId,
      title: actionName,
    };

    if (actionId === actionIds.view) {
      this.router.navigate(["auction/" + uuid]);
    } else if (actionId === actionIds.edit) {
      this.goToEdit(uuid);
      this.router.navigate(["auction/edit/" + uuid]);
    } else if (actionId === actionIds.publish) {
      this.actionConfirmationModalState = true;
    } else if (actionId === actionIds.duplicate) {
      this.goToDuplicate(uuid);
    } else if (actionId === actionIds.finish) {
      this.auctionManuallyFinish(uuid);
    } else if (actionId === actionIds.fail) {
      this.auctionManuallyFail(uuid);
    } else if (actionId === actionIds.stop) {
      this.isFormModalOpen = uuid;
      this.actionsModalComponent = "";
    } else if (actionId === actionIds.delete) {
      this.actionConfirmationModalState = true;
    } else if (actionId === actionIds.cancelPublish) {
      this.actionConfirmationModalState = true;
    }
  }

  closeFormModal() {
    this.auctionStopModalLoader = false;
    this.isFormModalOpen = "";
    this.form.get("reason").reset();
    (this.form.get("files") as FormArray).clear();
  }

  openResultsModal(uuid = "") {
    this.isResultsModalOpen = true;
    document.getElementsByTagName("body")[0].classList.add("overflow-hidden");
    this.myAuctionsList.find((item) => {
      if (item.uuid === uuid) {
        this.auctionResultsData = item;
      }
    });
  }

  closeResultsModal() {
    document
      .getElementsByTagName("body")[0]
      .classList.remove("overflow-hidden");
    this.isResultsModalOpen = false;
  }

  actionConfirmationModal(state: Boolean, id?: number) {
    if (state) {
      if (id === actionIds.publish) {
        this.auctionPusblish(this.actionConfirmationModalData.uuid);
      }
      if (id === actionIds.delete) {
        this.auctionDelete(this.actionConfirmationModalData.uuid);
      }
      if (id === actionIds.cancelPublish) {
        this.auctionCancelPusblishRequest(
          this.actionConfirmationModalData.uuid,
        );
      }
    } else {
      this.actionConfirmationModalLoader = false;
      this.actionConfirmationModalState = false;
      delete this.actionConfirmationModalContent;
    }
  }

  isActionDisabled(actionId, item) {
    // view and duplicate is always visible
    if (actionId === actionIds.edit) {
      return !(
        item.status_key === "active" ||
        item.status_key === "not_started" ||
        item.status_key === "unpublished"
      );
    }
    if (actionId === actionIds.publish) {
      return !item.can_be_published;
    }
    if (actionId === actionIds.finish) {
      return !item.can_be_manually_finished;
    }
    if (actionId === actionIds.fail) {
      return !item.can_be_manually_failed;
    }
    if (actionId === actionIds.stop) {
      return !item.can_be_stopped;
    }
    if (actionId === actionIds.delete) {
      return !item.can_be_deleted;
    }
  }

  isActionHidden(actionId, item) {
    if (actionId === actionIds.cancelPublish) {
      return item.publish_request_sent;
    }
    if (actionId === actionIds.publish) {
      return (
        !item.publish_request_sent &&
        item.status_key === "unpublished" &&
        this.serverTime < Date.parse(item.end_date) / 1000
      );
    }
    return true;
  }

  openCloseStatuses() {
    this.isStatusOpen = !this.isStatusOpen;
    this.isDateFilterOpen = false;
  }

  openCloseDatesFilter() {
    this.isDateFilterOpen = !this.isDateFilterOpen;
    this.isStatusOpen = false;
  }

  saveFilter() {
    this.paginationData["page"] = 1;
    this.getParentData();
    this.filterDropdownWeb.hide();
    this.filterDropdownMobile.hide();
  }

  clearFilter() {
    this.paginationData["page"] = 1;
    this.filterForm.reset();
    this.getParentData();
  }

  resultsExport() {
    if (this.myAuctionsList.length) {
      const params: filterQueryParams = {};

      params.statuses = this.filterForm.get("status").value.length
        ? this.filterForm.get("status").value.join(",")
        : "";

      if (this.filterForm.get("active_from").value) {
        params.active_from = this.formatFilterDate(
          this.filterForm.get("active_from").value,
        );
      }

      if (this.filterForm.get("active_to").value) {
        params.active_to = this.formatFilterDate(
          this.filterForm.get("active_to").value,
        );
      }

      this.apiService
        .get(`/profile/auctions/export-manageable`, {
          responseType: "blob",
          params: params,
        })
        .subscribe(
          (response) => {
            const blob: any = new Blob([response], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const fileSaver = require("file-saver");
            fileSaver.saveAs(blob, "შედეგები.xlsx");
          },
          (error) => console.log(error),
        );
    }
  }

  uploadFiles(event) {
    for (let file of event.target.files) {
      if (file) {
        (this.manualStopReasonForm.get("files") as FormArray).push(
          new FormControl(file),
        );
      }
    }
  }

  removeFile(fileIndex: number) {
    (this.manualStopReasonForm.get("files") as FormArray).removeAt(fileIndex);
  }

  get getCurrentParentTab() {
    return this.currentParentTab;
  }

  get getIsStatusOpen() {
    return this.isStatusOpen;
  }

  get getIsDateFilterOpen() {
    return this.isDateFilterOpen;
  }

  get getAuctionStatuses() {
    return this.auctionStatuses;
  }

  get getUserInformation() {
    return this.userInformation;
  }

  get userCanManageAuctions() {
    return this.canUserManageOwnAuctions;
  }

  get getServerTime() {
    return this.serverTime;
  }

  // get formatedTabs() {
  //   return this.currentParentTab === 'participated' ? this.tabs.slice(0, this.tabs.length - 1) : this.tabs;
  // }

  get form() {
    return this.manualStopReasonForm;
  }

  get filterForm() {
    return this.auctionFilterForm;
  }

  get getActions() {
    return this.actions;
  }

  get getCanUserManageOwnAuctions() {
    return this.canUserManageOwnAuctions;
  }

  get getActionsModalComponent() {
    return this.actionsModalComponent;
  }

  get currentPage() {
    return this.currentPageNumber;
  }

  get myAuctionsList() {
    return this.myAuctions;
  }

  get totalPages() {
    const data = [];
    for (let i = 1; i <= this.lastPage; i++) {
      data.push(i);
    }
    return data;
  }

  get currentDate() {
    return moment(new Date()).locale("ka").format(`DD/MM/YYYY`);
  }

  get finalPrice() {
    return (
      parseFloat(this.auctionResultsData.current_price) -
      parseFloat(this.auctionResultsData.warranty_price)
    ).toFixed(2);
  }

  get paymentExpirationDate() {
    return moment(
      new Date(this.auctionResultsData.end_date).setDate(
        new Date(this.auctionResultsData.end_date).getDate() +
          this.auctionResultsData.payment_period,
      ),
    )
      .locale("ka")
      .format(`DD/MM/YYYY`);
  }

  get invoiceButtonState() {
    const paymentLastDate = moment(
      new Date(this.auctionResultsData.end_date).setDate(
        new Date(this.auctionResultsData.end_date).getDate() +
          this.auctionResultsData.payment_period,
      ),
    ).toDate();

    paymentLastDate.setHours(23);
    paymentLastDate.setMinutes(59);
    paymentLastDate.setSeconds(59);

    return paymentLastDate > new Date(this.serverTime * 1000);
  }

  get actionConfirmationModalData() {
    return this.actionConfirmationModalContent;
  }

  ngOnDestroy() {
    if (this.myAuctionsSubscription) {
      this.myAuctionsSubscription.unsubscribe();
    }
    if (this.auctionStatusesSubscription) {
      this.auctionStatusesSubscription.unsubscribe();
    }
    if (this.bidUpdateSubscription) {
      this.bidUpdateSubscription.unsubscribe();
    }
    if (this.serverTimeSubscription) {
      this.serverTimeSubscription.unsubscribe();
    }
    if (this.currentParentTabSubscription) {
      this.currentParentTabSubscription.unsubscribe();
    }
  }
}
